<template>
    <div>
            <b-card>
                <b-row class="mb-1">
                    <b-col lg="4">
                    </b-col>
                    <b-col lg="8" class="d-flex justify-content-end align-items-center">
                      <template v-if="$permissionAbility(MAIL_TEMPLATE_CREATE, permissions)">
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            class="flex-shrink-0"
                            variant="primary"
                            @click="showMailTemplateModal"
                        >
                            Create Mail Template
                        </b-button>
                    </template>
                    </b-col>
                </b-row>
            <!-- table -->
            <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :is-loading.sync="isLoading"
                :rows="rows"
                :sort-options="{
                enabled: false,
                multipleColumns: true,
                initialSortBy: [
                    { field: 'id', type: 'desc' },
                    { field: 'name', type: 'desc' },
                    { field: 'created_at', type: 'desc' },
                ],
                }"
                :columns="columns"
                :pagination-options="{
                enabled: true,
                perPage: pageLength,
                }"
                style-class="vgt-table striped"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
            >
                <template
                slot="table-row"
                slot-scope="props"
                >
               
                <span v-if="props.column.field === 'template_name_format'">
                    {{ truncateText(props.row.template_name) }}
                </span>
                <span v-if="props.column.field === 'subject_format'">
                    {{ truncateText(props.row.subject) }}
                </span>
        
                <span v-if="props.column.field === 'action'">
                    <template v-if="$permissionAbility(MAIL_TEMPLATE_EDIT, permissions)">
                      <span @click="onShow(props.row)">
                          <feather-icon
                              v-b-tooltip.hover
                              icon="Edit2Icon"
                              class="mr-50 custom-icon cursor-pointer"
                              title="Edit"
                              size="16"
                          />
                      </span>
                    </template>
                    <template v-if="$permissionAbility(MAIL_TEMPLATE_DELETE, permissions)">
                      <span>
                          <feather-icon @click="onDelete(props.row)"
                              v-b-tooltip.hover
                              icon="Trash2Icon"
                              class="mr-50 custom-icon cursor-pointer"
                              title="Delete"
                              size="16"
                          />
                      </span>
                    </template>
                    <template v-if="$permissionAbility(MAIL_SEND, permissions)">
                      <span>
                          <feather-icon @click="showCompanyModal(props.row)"
                              v-b-tooltip.hover
                              icon="UserCheckIcon"
                              class="mr-50 custom-icon cursor-pointer"
                              title="Select Company"
                              size="16"
                          />
                      </span>
                    </template>
                </span>
        
                <!-- Column: Common -->
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
                </template>
        
                <!-- pagination -->
                <template
                slot="pagination-bottom"
                slot-scope="props"
                >
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Showing 1 to </span>
                    <b-form-select
                        v-model="pageLength"
                        :options="['10', '25', '50', '100', '500']"
                        class="mx-1"
                        @input="
                        (value) => props.perPageChanged({ currentPerPage: value })
                        "
                    />
                    <span class="text-nowrap"> of {{ props.total }} entries </span>
                    </div>
                    <div>
                    <b-pagination
                        :value="1"
                        :total-rows="props.total"
                        :per-page="pageLength"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="mt-1 mb-0"
                        @input="(value) => props.pageChanged({ currentPage: value })"
                    >
                        <template #prev-text>
                        <feather-icon
                            icon="ChevronLeftIcon"
                            size="18"
                        />
                        </template>
                        <template #next-text>
                        <feather-icon
                            icon="ChevronRightIcon"
                            size="18"
                        />
                        </template>
                    </b-pagination>
                    </div>
                </div>
                </template>
            </vue-good-table>
            </b-card>
    
    <b-modal
          id="modal-mail-template-model"
          centered
          :title="modelType === 'editModel' ? 'Edit Mail Template' : 'Create Mail Template'"
          hide-footer
          no-close-on-backdrop
          @hidden="hiddenMailTemplateModal"
          size="lg"
        >
          <validation-observer ref="mailTemplateCreate">
            <b-form @submit.prevent="validMailTemplateCreate">
              <!-- name -->
              <b-form-group label="Template Name" label-for="template_name" class="required-label">
                <validation-provider
                    #default="{ errors }"
                    type="text"
                    name="template name"
                    vid="template_name"
                    rules="required|max:255"
                >
                    <b-form-input
                    id="template_name"
                    v-model="template_name"
                    type="text"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Template name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                </b-form-group>
                <b-form-group label="Subject" label-for="subject" class="required-label">
                <validation-provider
                    #default="{ errors }"
                    name="subject"
                    vid="subject"
                    rules="required|max:255"
                >
                    <b-form-input
                    id="subject"
                    v-model="subject"
                    type="text"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Mail Subject"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                </b-form-group>
              <b-form-group
                  label="Body "
                  label-for="body"
                  class="required-label"
                >
                  <validation-provider
                    name="body"
                    vid="body"
                    #default="{ errors }"
                    rules="required|max:255"
                  >
                  <div :class="{ fullscreen: isFullscreen }">
                    <quill-editor
                      v-model="body"
                      :options="editorOption"
                      :style="{
                        height: '13rem !important',
                        paddingBottom: '5rem !important',
                      }"
                      class="custom-quill-editor"
                    >
                      <div id="toolbar" slot="toolbar">
                        <!-- Add a bold button -->
                        <span class="ql-formats">
                          <button class="ql-bold">Bold</button>
                          <button class="ql-italic">Italic</button>
                          <button class="ql-underline">Underline</button>
                          <button class="ql-strike">Strike</button>
                          <button class="ql-blockquote"></button>
                          <button class="ql-list" value="ordered"></button>
                          <button class="ql-list" value="bullet"></button>
                          <button class="ql-script" value="sub"></button>
                          <button class="ql-script" value="super"></button>
                          <button class="ql-indent" value="-1"></button>
                          <button class="ql-indent" value="+1"></button>
                          <button class="ql-direction" value="rtl"></button>
                          <button class="ql-align" value=""></button>
                          <button class="ql-align" value="center"></button>
                          <button class="ql-align" value="right"></button>
                          <button class="ql-align" value="justify"></button>
                          <select class="ql-color"></select>
                          <select class="ql-background"></select>
                          <select class="ql-size">
                            <option value="small" />

                            <option selected />
                            <option value="large" />
                            <option value="huge" />
                          </select>

                          <select class="ql-font"></select>
                          <select class="ql-header">
                            <option value="1">Heading 1</option>
                            <option value="2">Heading 2</option>
                            <option value="3">Heading 3</option>
                            <option value="4">Heading 4</option>
                            <option value="5">Heading 5</option>
                            <option value="6">Heading 6</option>
                            <option selected>Normal</option>
                          </select>

                          <button class="ql-link"></button>
                          <button type="button" :title="isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'" class="fullscreen-btn" @click="toggleFullscreen">
                            🔳
                          </button>
                        </span>
                      </div>
                    </quill-editor>
                  </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
  
              <!-- loading button -->
              <template v-if="isMailTemplateFromSubmitLoading">
                <b-button class="float-right" variant="primary" disabled>
                  <b-spinner small />
                  Loading...
                </b-button>
              </template>
  
              <!-- submit button -->
              <template v-else>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  class="float-right"
                  variant="primary"
                >
                  Submit
                </b-button>
              </template>
            </b-form>
          </validation-observer>
        </b-modal>

        <b-modal
          id="modal-company-model"
          centered
          title="Select company to sent mail"
          hide-footer
          no-close-on-backdrop
          @hidden="hiddenCompanyModal"
          size="md"
        >
          <validation-observer ref="companyToMailSent">
            <b-form @submit.prevent="selectCompanyToMailSent">
              <b-form-checkbox v-model="selectAllCompanies" @click="toggleSelectAll" :disabled="selectedStatuses.length > 0">
                  Check all company to sent mail
              </b-form-checkbox>
              <hr>
              <b-form-group label="Check Status Wise Company to Sent mail">
                <b-form-checkbox 
                  v-for="(status, key) in statusOptions" 
                  :key="key" 
                  v-model="selectedStatuses"
                  :value="status.id"
                  @click="toggleStatus"
                  :disabled="selectAllCompanies"
                >
                  {{ status.label }}
                </b-form-checkbox>
              </b-form-group>
              <b-form-group label="Select Company" label-for="company_id">
              <ValidationProvider name="company_id" vid="company_id">
                  <v-select
                    id="company_id"
                    placeholder="Select Company"
                    v-model="companyList"
                    :options="companyOptions"
                    :reduce="(item) => item?.id"
                    label="name"
                    multiple
                    :disabled="selectAllCompanies || selectedStatuses.length > 0"
                    :close-on-select="false"
                  >
                    </v-select>
              </ValidationProvider>
            </b-form-group>

              <b-form-group>
                <h5>If you want to send E-mail specific date & time then select otherwise keep it as is</h5>
                <flat-pickr
                  v-model="dateNtim"
                  class="form-control"
                  :config="{ enableTime: true, dateFormat: 'Y-m-d H:i'}"
                />
              </b-form-group>
              <!-- loading button -->
              <template v-if="isCompanySelectFromSubmitLoading">
                <b-button class="float-right" variant="primary" disabled>
                  <b-spinner small />
                  Loading...
                </b-button>
              </template>
  
              <!-- submit button -->
              <template v-else>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  class="float-right"
                  variant="primary"
                >
                  Submit
                </b-button>
              </template>
            </b-form>
          </validation-observer>
        </b-modal>
    </div>
  </template>
  
  <script>
  import flatPickr from 'vue-flatpickr-component'
  import {
    BCard,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    BForm,
    BModal,
    BSpinner,
    BFormDatepicker,
    BLink, VBTooltip, BRow, BCol, BFormTextarea,
    BFormCheckbox,
  } from 'bootstrap-vue'
  import { VueGoodTable } from 'vue-good-table'
  import Ripple from 'vue-ripple-directive'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { required, max } from "@validations";
  import { quillEditor } from "vue-quill-editor";
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import UserCard from '@/layouts/components/UserCard.vue'
  import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
  import { mapGetters } from 'vuex'
  import {
    MAIL_TEMPLATE_CREATE,
    MAIL_TEMPLATE_EDIT,
    MAIL_TEMPLATE_DELETE,
    MAIL_SEND,
  } from '@/helpers/superAdminPermissionConstant'
  export default {
    name: 'CompanyRequestView',
    components: {
      BFormTextarea,
      BCol,
      BRow,
      BForm,
      BButton,
      BCard,
      VueGoodTable,
      BAvatar,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      ValidationProvider,
      ValidationObserver,
      BModal,
      BSpinner,
      BLink,
      quillEditor,
      UserCard,
      BCardActions,
      BFormDatepicker,
      flatPickr,
      BFormCheckbox,
    },
    directives: {
      Ripple,
      'b-tooltip': VBTooltip,
    },
    data() {
      return {
        MAIL_TEMPLATE_CREATE,
        MAIL_TEMPLATE_EDIT,
        MAIL_TEMPLATE_DELETE,
        MAIL_SEND,
        subject: "",
        template_name: "",
        body: "",
        modelType:"",
        mailTemplateId: "",
        companyOptions: [],
        companyList:[],
        selectAllCompanies: false,
        selectedStatuses: [],
        dateNtim: null,
        statusOptions: [
          { id: 1, label: "Complete" },
          { id: 2, label: "On Payment" },
          { id: 3, label: "Pause" },
          { id: 4, label: "Resume" },
          { id: 5, label: "Cancel" },
          { id: 6, label: "Trial" },
        ],
        editorOption: {
            modules: {
            toolbar: "#toolbar",
            },
        },
        pageLength: 10,
        columns: [
          {
            label: 'Template Name',
            field: 'template_name_format',
          },
          {
            label: 'Subject',
            field: 'subject_format',
          },
          {
            label: 'CreatedAt',
            field: 'created_at',
          },
          {
            label: 'Action',
            field: 'action',
            sortable: false,
          },
        ],
        rows: [],
        searchTerm: '',
        delayTimer: null,
        isLoading: false,
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            { field: 'id', type: 'desc' },
            { field: 'name', type: 'desc' },
          ],
          page: 1,
          perPage: 10,
        },
        isMailTemplateFromSubmitLoading: false,
        isCompanySelectFromSubmitLoading: false,
        isFullscreen: false,
      }
    },
    computed: {
    ...mapGetters({
        permissions: 'superAdminAuthModule/getPermissions',
      }),
    },
  
  
    methods: {
      onSearch() {
        if (this.delayTimer) {
          clearTimeout(this.delayTimer)
          this.delayTimer = null
        }
  
        this.delayTimer = setTimeout(() => {
          this.loadItems()
        }, 1000)
      },
      showMailTemplateModal() {
        this.$bvModal.show("modal-mail-template-model");
      },
  
      hiddenMailTemplateModal() {
        this.$bvModal.hide("modal-mail-template-model");
        this.resetMailTemplateModal();
      },
  
      async onShow(value) {
      this.modelType = "editModel";
      this.template_name = value.template_name;
      this.subject = value.subject;
      this.body = value.body;
      this.mailTemplateId = value.id;

      this.showMailTemplateModal();
    },
      resetMailTemplateModal() {
        this.subject = ""
        this.template_name = ""
        this.body = ""
      },

      showCompanyModal(data) {
        this.mailTemplateId = data.id;
        this.$bvModal.show("modal-company-model");
      },
  
      hiddenCompanyModal() {
        this.$bvModal.hide("modal-company-model");
        this.resetCompanyModal();
      },
  
      resetCompanyModal() {
        this.companyList = [];
        this.selectAllCompanies = false;
        this.selectedStatuses = [];
        this.mailTemplateId = '';
        this.dateNtim = null;
      },
  
      updateParams(newProps) {
        this.serverParams = { ...this.serverParams, ...newProps }
      },
  
      onPageChange(params) {
        this.updateParams({ page: params.currentPage })
        this.loadItems()
      },
  
      onPerPageChange(params) {
        this.updateParams({ perPage: params.currentPerPage })
        this.loadItems()
      },
  
      onSortChange(params) {
        this.updateParams({
          sort: params,
        })
        this.loadItems()
      },
  
      onColumnFilter(params) {
        this.updateParams(params)
        this.loadItems()
      },
      async onDelete(row) {
      const { id, template_name } = row;
      this.$swal({
        title: "Warning!",
        text: `Are You Sure You Want To Delete ${template_name}?`,
        icon: "warning",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Delete",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await this.$api.delete(`/api/super-admin/mail-templates/${id}`);

            this.loadItems();

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: response.data.message,
              },
            });
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: error?.response?.data?.message,
              },
            });
          }
        }
      });
    },
      async validMailTemplateCreate() {
        this.$refs.mailTemplateCreate.validate().then(async (success) => {
          if (success) {
            try { 
              
                this.isMailTemplateFromSubmitLoading = true;
                let formData = {
                    template_name: this.template_name,
                    subject: this.subject,
                    body: this.body
                };
                let response;
                if (this.modelType === 'editModel') {
                    response = await this.$api.put(
                    `/api/super-admin/mail-templates/${this.mailTemplateId}`,
                    formData,
                    );
                } else {
                    response = await this.$api.post(
                    "/api/super-admin/mail-templates",
                    formData,
                    );
                }
                
                this.isMailTemplateFromSubmitLoading = false;
                this.hiddenMailTemplateModal();
  
                this.loadItems();
  
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: response?.data?.message,
                  },
                });
            } catch (error) {
              this.isMailTemplateFromSubmitLoading = false;
  
              if (error?.response?.data?.message) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: error?.response?.data?.message,
                  },
                });
              }
  
              if (error?.response?.data?.errors) {
                this.$refs.companyValidation.setErrors(
                  error?.response?.data?.errors
                );
              }
            }
          }
        });
      },

      async selectCompanyToMailSent() {
        this.$refs.companyToMailSent.validate().then(async (success) => {
          if (success) {
            try { 
              
                this.isCompanySelectFromSubmitLoading = true;
                let formData = {
                    company_ids: this.companyList,
                    all_company: this.selectAllCompanies,
                    statuses: this.selectedStatuses,
                    mail_template_id: this.mailTemplateId,
                    date_time: this.dateNtim,
                };

                const response = await this.$api.post(
                    "/api/super-admin/send-mail",
                    formData,
                    );
                
                this.isCompanySelectFromSubmitLoading = false;
                this.hiddenCompanyModal();
  
                this.loadItems();
  
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: response?.data?.message,
                  },
                });
            } catch (error) {
              this.isMailTemplateFromSubmitLoading = false;
  
              if (error?.response?.data?.message) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: error?.response?.data?.message,
                  },
                });
              }
  
              if (error?.response?.data?.errors) {
                this.$refs.companyValidation.setErrors(
                  error?.response?.data?.errors
                );
              }
            }
          }
        });
      },
  
      async getMailTemplates(params) {
        return await this.$api.get('api/super-admin/mail-templates', {
          params: {
            show: params.show,
            page: params.page,
            sort: params.sort,
          },
        })
      },
  
      async getAllCompanies() {
        return await this.$api.get("api/super-admin/mail-template-companies");
        },
      async loadItems() {
        try {
          const [mailTemplate, companies] = await Promise.all([
            this.getMailTemplates({
              show: this.serverParams.perPage,
              page: this.serverParams.page,
              sort: this.serverParams.sort,
            }),
            this.getAllCompanies(),
          ])
  
          const data = mailTemplate?.data?.data
          const meta = mailTemplate?.data?.meta
          const companyData = companies?.data;
          this.companyOptions = companyData.map((item) => {
            return {
              id: item.id,
              name: item?.name,
              email: item?.email,
            }
          });

          this.totalRecords = meta?.pagination?.total
          this.rows = data
        } catch (error) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Warning',
              icon: 'BellIcon',
              variant: 'warning',
              text: error?.response?.data?.message,
            },
          })
        }
      },
      toggleFullscreen() {
        this.isFullscreen = !this.isFullscreen;
      },
      truncateText(text) {
            if (!text) return ""; // Handle empty cases
            return text.length > 15 ? text.substring(0, 15) + "..." : text;
      },
      toggleSelectAll() {
        this.selectAllCompanies = !this.selectAllCompanies;
    },
    toggleStatus() {
      if (this.selectedStatuses.length > 0) {
        this.selectAllCompanies = false; // Uncheck "Select All" if any status is selected
      }
    },
    
    },
  }
  </script>
  
  <style lang="scss">
  @import "@core/scss/vue/libs/vue-good-table.scss";
  @import "@core/scss/vue/libs/quill.scss";
  @import '@core/scss/vue/libs/vue-flatpicker';


/* Fullscreen mode */
.fullscreen {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 9999;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

/* Adjust editor and toolbar in fullscreen mode */
.fullscreen .ql-container {
  height: calc(100vh - 50px) !important;
}

.fullscreen .ql-toolbar {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1000;
  padding: 10px;
}

/* Fullscreen button styling */
.fullscreen-btn {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 18px;
  margin-left: 10px;
}
  </style>
  